import Cookies from "js-cookie";

export const cookies = Cookies.withConverter({
  read: function (value, name) {
    return JSON.parse(value);
  },
  write: function (value, name) {
    return JSON.stringify(value);
  },
});

const CookieReducer = (state: any, action: { type: any; payload: any }) => {
  const { type, payload = {} } = action;
  let newState;
  switch (type) {
    case "LOAD":
      const result = cookies.get("carbando");
      if (!result) return {};
      return result;

    case "SET":
      newState = { ...state, [payload.name]: payload.value };
      break;

    case "ADD":
      delete state[payload.name];
      newState = { ...state, [payload.name]: payload.value };
      break;

    case "DELETE":
      newState = { ...state };
      delete newState[payload.name];
      break;

    default:
      return state;
  }
  cookies.set("carbando", newState);
  return { ...newState };
};

export default CookieReducer;
